var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ChatRoom",
    _vm._b(
      {
        attrs: {
          title: _vm.$t("details"),
          enableFileUpload: "",
          createConnection: "",
          noLastRead: ""
        },
        scopedSlots: _vm._u([
          {
            key: "issue",
            fn: function() {
              return [
                _c(
                  "v-card",
                  { attrs: { hover: "", raised: "" } },
                  [
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-layout",
                          [
                            _c("v-flex", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("trackings")) + ":")
                              ])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          _vm._l(_vm.item.trackings, function(tracking) {
                            return _c(
                              "v-flex",
                              { key: tracking, attrs: { xs4: "" } },
                              [
                                _c(
                                  "span",
                                  { staticClass: "non-uploaded-tracking" },
                                  [_vm._v(_vm._s(tracking))]
                                )
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          _vm._l(_vm.item.uploadedFiles, function(file, index) {
                            return _c("FsFileChip", {
                              key: "file" + index,
                              staticClass: "ma-2",
                              attrs: {
                                file: file,
                                width: "100%",
                                "aspect-ratio": "1.7"
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.showChatRoom,
          callback: function($$v) {
            _vm.showChatRoom = $$v
          },
          expression: "showChatRoom"
        }
      },
      "ChatRoom",
      _vm.chatRoomBind,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46987f74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46987f74","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnScannedDetailPopup.vue
// module id = null
// module chunks = 